import { MutationTree } from 'vuex';
import { ISanityDocumentState, TDocStoreMutationPayloads } from './types';

export const getStoreMutations = (): MutationTree<ISanityDocumentState> => {
  return {
    clearCache(state, payload: TDocStoreMutationPayloads['clearCache']) {
      if (payload.namespace) {
        if (payload.namespace === 'subscription') {
          if (state.subscription && !state.subscription?.closed) {
            state.subscription.unsubscribe();
          }
          state.subscription = undefined;
        } else {
          state[payload.namespace] = {};
        }
      } else {
        if (state.subscription && !state.subscription?.closed) {
          state.subscription.unsubscribe();
        }
        state.subscription = undefined;
        state.watched = {};
        state.documents = {};
        state.slugs = {};
      }
    },

    updateDocuments(
      state,
      payload: TDocStoreMutationPayloads['updateDocuments'],
    ) {
      if (payload.documents) {
        state.documents = {
          ...state.documents,
          ...payload.documents,
        };
      }
    },

    updateSlugs(state, payload: TDocStoreMutationPayloads['updateSlugs']) {
      if (payload.slugs) {
        state.slugs = {
          ...state.slugs,
          ...payload.slugs,
        };
      }
    },

    updateSubscription(
      state,
      payload: TDocStoreMutationPayloads['updateSubscription'],
    ) {
      if (state.subscription && !state.subscription.closed) {
        state.subscription.unsubscribe();
      }
      state.subscription = payload.subscription || undefined;
    },

    updateWatched(state, payload: TDocStoreMutationPayloads['updateWatched']) {
      state.watched = {
        ...state.watched,
        ...payload.watched,
      };
    },
  };
};
